import { render, staticRenderFns } from "./ProductTypes.vue?vue&type=template&id=846d2420&scoped=true&"
import script from "./ProductTypes.vue?vue&type=script&lang=ts&"
export * from "./ProductTypes.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTypes.vue?vue&type=style&index=0&id=846d2420&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846d2420",
  null
  
)

export default component.exports